import { Icon, IconProps } from "@chakra-ui/react";

export function Squiggle474x10Icon(props: IconProps) {
  return (
    <Icon {...props} viewBox="0 0 476 13">
      <path
        d="M1 11.75H271.155L62.399 1.75H475"
        stroke="currentColor"
        fill="transparent"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Icon>
  );
}
